<footer>
  <div class="container">
    <div class="redes row">
      <div class="col-xl-3 col-md-3 col-lg-3  col-3">
        <a href="https://www.facebook.com/pg/satlockcolombia/posts/"><i class="fab fa-facebook-f fa-2x"></i></a>
      </div>
      <div class="col-xl-3 col-3">
        <a href="https://twitter.com/satlockcolombia?lang=es"><i class="fab fa-twitter fa-2x"></i></a>
      </div>
      <div class="col-xl-3 col-3">
        <a href="https://www.youtube.com/channel/UCM20iHXnuOdwwTE9Al3RWOg"><i class="fab fa-youtube fa-2x"></i></a>
      </div>
      <div class="col-xl-3 col-3">
        <a href="https://co.linkedin.com/company/satlock"><i class="fab fa-linkedin fa-2x"></i></a>
      </div>
    </div>
    <hr>

    <div class="row contentInF" *ngFor="let dataF of data[0].default.footerEs" [ngSwitch]="idioma">
      <!-- ***************************************************************Caso Ingles************************************************************************ -->
      <ng-container *ngSwitchCase="'2'">
        <div class="col-xl-4 col-lg-4 col-md-4 col-12 more">
          <h4>{{dataF.masInfIn}}</h4>
          <hr>
          <p>
            Jimmy Alvarado - {{dataF.cargoIn}}
            <br><br>
            <a class="mail" href="mailto:sales@satlock.com">sales@satlock.com</a> <br>
            <a class="mail" href="mailto:jimmy.alvarado@satlock.com">jimmy.alvarado@satlock.com</a> <br>

            Cali PBX: (57-2) 483 6932/34
          </p>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-12">
          <div class="Contacnos">
            <h4>{{dataF.CorreoIn}}</h4>
            <hr>
            <div>
              <a href="mailto:support@satlock.com"><i class="fas fa-mail-bulk fa-2x"></i>
                <span> support@satlock.com</span>
              </a>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-12">
          <div class="support">
            <h4>{{dataF.SoporteIn}}</h4>
            <hr>
            <div>
              <a href="https://wa.me/573132525077"><i class="fab fa-whatsapp fa-2x"></i>
                <span> +57 3132525077</span>
              </a>
            </div>
            <!-- Enlace a WeChat-->
            <div>
              <a data-toggle="modal" data-target="#exampleModalCenter1"><i class="fab fa-weixin fa-2x"></i>
                <span> Wechat</span>
              </a>
              <div class="modal fade" id="exampleModalCenter1" tabindex="-1" role="dialog"
                aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <ng-container>
                        <h5 class="modal-title">ID Wechat : supportsatlock</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                            aria-hidden="true">&times;</span></button>                    
                      </ng-container>
                    </div>
                    <div class="modal-body">
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xl-12">
                        <div class="row d-flex justify-content-between align-self-center contenTB">
                          <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12">
                            <a><img src="assets/img/QRWeChatSatlock.jpeg"></a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <!-- ***************************************************************Caso Chino************************************************************************ -->
      <ng-container *ngSwitchCase="'3'">
        <div class="col-xl-4 col-lg-4 col-md-4 col-12 more">
          <h4>{{dataF.masInfZh}}</h4>
          <hr>
          <p>
            Jimmy Alvarado - {{dataF.cargoZh}}
            <br><br>
            <a class="mail" href="mailto:sales@satlock.com">sales@satlock.com</a> <br>
            <a class="mail" href="mailto:jimmy.alvarado@satlock.com">jimmy.alvarado@satlock.com</a> <br>

            Cali PBX: (57-2) 483 6932/34
          </p>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-12">
          <div class="Contacnos">
            <h4>{{dataF.CorreoZh}}</h4>
            <hr>
            <div>
              <a href="mailto:support@satlock.com"><i class="fas fa-mail-bulk fa-2x"></i>
                <span> support@satlock.com</span>
              </a>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-12">
          <div class="support">
            <h4>{{dataF.SoporteZh}}</h4>
            <hr>
            <div>
              <a href="https://wa.me/573132525077"><i class="fab fa-whatsapp fa-2x"></i>
                <span> +57 3132525077</span>
              </a>
            </div>
            <!-- Enlace a WeChat-->
            <div>
              <a data-toggle="modal" data-target="#exampleModalCenter1"><i class="fab fa-weixin fa-2x"></i>
                <span> Wechat</span>
              </a>
              <div class="modal fade" id="exampleModalCenter1" tabindex="-1" role="dialog"
                aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <ng-container>
                        <h5 class="modal-title">ID Wechat : supportsatlock</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                            aria-hidden="true">&times;</span></button>                    
                      </ng-container>
                    </div>
                    <div class="modal-body">
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xl-12">
                        <div class="row d-flex justify-content-between align-self-center contenTB">
                          <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12">
                            <a><img src="assets/img/QRWeChatSatlock.jpeg"></a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <!-- ***************************************************************Caso Español************************************************************************ -->
      <ng-container *ngSwitchDefault>
        <div class="col-xl-4 col-lg-4 col-md-4 col-12 more">
          <h4>{{dataF.masInfEs}}</h4>
          <hr>
          <p>
            Jimmy Alvarado - {{dataF.cargoEs}}
            <br><br>
            <a class="mail" href="mailto:sales@satlock.com">sales@satlock.com</a> <br>
            <a class="mail" href="mailto:jimmy.alvarado@satlock.com">jimmy.alvarado@satlock.com</a> <br>

            Cali PBX: (57-2) 483 6932/34
          </p>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-12">
          <div class="Contacnos">
            <h4>{{dataF.CorreoEs}}</h4>
            <hr>
            <div>
              <a href="mailto:support@satlock.com"><i class="fas fa-mail-bulk fa-2x"></i>
                <span> support@satlock.com</span>
              </a>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-12">
          <div class="support">
            <h4>{{dataF.SoporteEs}}</h4>
            <hr>
            <div>
              <a href="https://wa.me/573132525077"><i class="fab fa-whatsapp fa-2x"></i>
                <span> +57 3132525077</span>
              </a>
            </div>
            <!-- Enlace a WeChat-->
            <div>
              <a data-toggle="modal" data-target="#exampleModalCenter1"><i class="fab fa-weixin fa-2x"></i>
                <span> Wechat</span>
              </a>
              <div class="modal fade" id="exampleModalCenter1" tabindex="-1" role="dialog"
                aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <ng-container>
                        <h5 class="modal-title">ID Wechat : supportsatlock</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                            aria-hidden="true">&times;</span></button>                    
                      </ng-container>
                    </div>
                    <div class="modal-body">
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xl-12">
                        <div class="row d-flex justify-content-between align-self-center contenTB">
                          <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12">
                            <a><img src="assets/img/QRWeChatSatlock.jpeg"></a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <!-- ***************************************************************Caso Frances************************************************************************ -->
      <ng-container *ngSwitchCase="'4'">
        <div class="col-xl-4 col-lg-4 col-md-4 col-12 more">
          <h4>{{dataF.masInfFr}}</h4>
          <hr>
          <p>
            Jimmy Alvarado - {{dataF.cargoFr}}
            <br><br>
            <a class="mail" href="mailto:sales@satlock.com">sales@satlock.com</a> <br>
            <a class="mail" href="mailto:jimmy.alvarado@satlock.com">jimmy.alvarado@satlock.com</a> <br>

            Cali PBX: (57-2) 483 6932/34
          </p>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-12">
          <div class="Contacnos">
            <h4>{{dataF.CorreoFr}}</h4>
            <hr>
            <div>
              <a href="mailto:support@satlock.com"><i class="fas fa-mail-bulk fa-2x"></i>
                <span> support@satlock.com</span>
              </a>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-12">
          <div class="support">
            <h4>{{dataF.SoporteFr}}</h4>
            <hr>
            <div>
              <a href="https://wa.me/573132525077"><i class="fab fa-whatsapp fa-2x"></i>
                <span> +57 3132525077</span>
              </a>
            </div>
            <!-- Enlace a WeChat-->
            <div>
              <a data-toggle="modal" data-target="#exampleModalCenter1"><i class="fab fa-weixin fa-2x"></i>
                <span> Wechat</span>
              </a>
              <div class="modal fade" id="exampleModalCenter1" tabindex="-1" role="dialog"
                aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <ng-container>
                        <h5 class="modal-title">ID Wechat : supportsatlock</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                            aria-hidden="true">&times;</span></button>                    
                      </ng-container>
                    </div>
                    <div class="modal-body">
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xl-12">
                        <div class="row d-flex justify-content-between align-self-center contenTB">
                          <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12">
                            <a><img src="assets/img/QRWeChatSatlock.jpeg"></a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <!-- ***************************************************************Caso Aleman************************************************************************ -->
      <ng-container *ngSwitchCase="'5'">
        <div class="col-xl-4 col-lg-4 col-md-4 col-12 more">
          <h4>{{dataF.masInfDe}}</h4>
          <hr>
          <p>
            Jimmy Alvarado - {{dataF.cargoDe}}
            <br><br>
            <a class="mail" href="mailto:sales@satlock.com">sales@satlock.com</a> <br>
            <a class="mail" href="mailto:jimmy.alvarado@satlock.com">jimmy.alvarado@satlock.com</a> <br>

            Cali PBX: (57-2) 483 6932/34
          </p>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-12">
          <div class="Contacnos">
            <h4>{{dataF.CorreoDe}}</h4>
            <hr>
            <div>
              <a href="mailto:support@satlock.com"><i class="fas fa-mail-bulk fa-2x"></i>
                <span> support@satlock.com</span>
              </a>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-12">
          <div class="support">
            <h4>{{dataF.SoporteDe}}</h4>
            <hr>
            <div>
              <a href="https://wa.me/573132525077"><i class="fab fa-whatsapp fa-2x"></i>
                <span> +57 3132525077</span>
              </a>
            </div>
            <!-- Enlace a WeChat-->
            <div>
              <a data-toggle="modal" data-target="#exampleModalCenter1"><i class="fab fa-weixin fa-2x"></i>
                <span> Wechat</span>
              </a>
              <div class="modal fade" id="exampleModalCenter1" tabindex="-1" role="dialog"
                aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <ng-container>
                        <h5 class="modal-title">ID Wechat : supportsatlock</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                            aria-hidden="true">&times;</span></button>                    
                      </ng-container>
                    </div>
                    <div class="modal-body">
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xl-12">
                        <div class="row d-flex justify-content-between align-self-center contenTB">
                          <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12">
                            <a><img src="assets/img/QRWeChatSatlock.jpeg"></a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <!-- ***************************************************************Caso Ruso************************************************************************ -->
      <ng-container *ngSwitchCase="'6'">
        <div class="col-xl-4 col-lg-4 col-md-4 col-12 more">
          <h4>{{dataF.masInfRu}}</h4>
          <hr>
          <p>
            Jimmy Alvarado - {{dataF.cargoRu}}
            <br><br>
            <a class="mail" href="mailto:sales@satlock.com">sales@satlock.com</a> <br>
            <a class="mail" href="mailto:jimmy.alvarado@satlock.com">jimmy.alvarado@satlock.com</a> <br>
            Cali PBX: (57-2) 483 6932/34
          </p>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-12">
          <div class="Contacnos">
            <h4>{{dataF.CorreoRu}}</h4>
            <hr>
            <div>
              <a href="mailto:support@satlock.com"><i class="fas fa-mail-bulk fa-2x"></i>
                <span> support@satlock.com</span>
              </a>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-12">
          <div class="support">
            <h4>{{dataF.SoporteRu}}</h4>
            <hr>
            <div>
              <a href="https://wa.me/573132525077"><i class="fab fa-whatsapp fa-2x"></i>
                <span> +57 3132525077</span>
              </a>
            </div>
            <!-- Enlace a WeChat-->
            <div>
              <a data-toggle="modal" data-target="#exampleModalCenter1"><i class="fab fa-weixin fa-2x"></i>
                <span> Wechat</span>
              </a>
              <div class="modal fade" id="exampleModalCenter1" tabindex="-1" role="dialog"
                aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <ng-container>
                        <h5 class="modal-title">ID Wechat : supportsatlock</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                            aria-hidden="true">&times;</span></button>                    
                      </ng-container>
                    </div>
                    <div class="modal-body">
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xl-12">
                        <div class="row d-flex justify-content-between align-self-center contenTB">
                          <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12">
                            <a><img src="assets/img/QRWeChatSatlock.jpeg"></a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <!-- ***************************************************************Caso Potugués Brasil************************************************************************ -->
      <ng-container *ngSwitchCase="'7'">
        <div class="col-xl-4 col-lg-4 col-md-4 col-12 more">
          <h4>{{dataF.masInfBr}}</h4>
          <hr>
          <p>
            Jimmy Alvarado - {{dataF.cargoBr}}
            <br><br>
            <a class="mail" href="mailto:sales@satlock.com">sales@satlock.com</a> <br>
            <a class="mail" href="mailto:jimmy.alvarado@satlock.com">jimmy.alvarado@satlock.com</a> <br>
            Cali PBX: (57-2) 483 6932/34
          </p>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-12">
          <div class="Contacnos">
            <h4>{{dataF.CorreoBr}}</h4>
            <hr>
            <div>
              <a href="mailto:support@satlock.com"><i class="fas fa-mail-bulk fa-2x"></i>
                <span> support@satlock.com</span>
              </a>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-12">
          <div class="support">
            <h4>{{dataF.SoporteBr}}</h4>
            <hr>
            <div>
              <a href="https://wa.me/573132525077"><i class="fab fa-whatsapp fa-2x"></i>
                <span> +57 3132525077</span>
              </a>
            </div>
            <!-- Enlace a WeChat-->
            <div>
              <a data-toggle="modal" data-target="#exampleModalCenter1"><i class="fab fa-weixin fa-2x"></i>
                <span> Wechat</span>
              </a>
              <div class="modal fade" id="exampleModalCenter1" tabindex="-1" role="dialog"
                aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <ng-container>
                        <h5 class="modal-title">ID Wechat : supportsatlock</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                            aria-hidden="true">&times;</span></button>                    
                      </ng-container>
                    </div>
                    <div class="modal-body">
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xl-12">
                        <div class="row d-flex justify-content-between align-self-center contenTB">
                          <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12">
                            <a><img src="assets/img/QRWeChatSatlock.jpeg"></a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <!-- ***************************************************************Caso Coreano************************************************************************ -->
      <ng-container *ngSwitchCase="'8'">
        <div class="col-xl-4 col-lg-4 col-md-4 col-12 more">
          <h4>{{dataF.masInfKr}}</h4>
          <hr>
          <p>
            Jimmy Alvarado - {{dataF.cargoKr}}
            <br><br>
            <a class="mail" href="mailto:sales@satlock.com">sales@satlock.com</a> <br>
            <a class="mail" href="mailto:jimmy.alvarado@satlock.com">jimmy.alvarado@satlock.com</a> <br>
            Cali PBX: (57-2) 483 6932/34
          </p>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-12">
          <div class="Contacnos">
            <h4>{{dataF.CorreoKr}}</h4>
            <hr>
            <div>
              <a href="mailto:support@satlock.com"><i class="fas fa-mail-bulk fa-2x"></i>
                <span> support@satlock.com</span>
              </a>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-12">
          <div class="support">
            <h4>{{dataF.SoporteKr}}</h4>
            <hr>
            <div>
              <a href="https://wa.me/573132525077"><i class="fab fa-whatsapp fa-2x"></i>
                <span> +57 3132525077</span>
              </a>
            </div>
            <!-- Enlace a WeChat-->
            <div>
              <a data-toggle="modal" data-target="#exampleModalCenter1"><i class="fab fa-weixin fa-2x"></i>
                <span> Wechat</span>
              </a>
              <div class="modal fade" id="exampleModalCenter1" tabindex="-1" role="dialog"
                aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <ng-container>
                        <h5 class="modal-title">ID Wechat : supportsatlock</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                            aria-hidden="true">&times;</span></button>                    
                      </ng-container>
                    </div>
                    <div class="modal-body">
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xl-12">
                        <div class="row d-flex justify-content-between align-self-center contenTB">
                          <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12">
                            <a><img src="assets/img/QRWeChatSatlock.jpeg"></a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</footer>
<div class="copyright">
  <div class="footer-copyright text-center py-3">© 2021 Copyright :
    <a href="http://satlock.com/wp/"> Satlock S.A.S </a>
  </div>
</div>
